import { post } from '@/api/implementation/app';

export default function () {
  return post('auth/logout');
}
